import { viemConnector as Dt, createAppClient as Be } from "@farcaster/auth-client";
export * from "@farcaster/auth-client";
import { jsx as y, jsxs as P, Fragment as j } from "react/jsx-runtime";
import * as I from "react";
import { createContext as Ie, useState as N, useEffect as F, useCallback as R, useContext as Me, useRef as Jt, useMemo as Ae } from "react";
import { createPortal as Ne } from "react-dom";
const Pe = typeof window < "u" && (window != null && window.location) ? {
  domain: window.location.host,
  siweUri: window.location.href
} : {}, qt = {
  relay: "https://relay.farcaster.xyz",
  version: "v1",
  ...Pe
}, Qt = Ie({
  isAuthenticated: !1,
  config: qt,
  profile: {},
  signInMessage: {},
  onSignIn: () => {
  },
  onSignOut: () => {
  }
});
function Te({
  config: t,
  children: e
}) {
  const [n, r] = N(), [o, i] = N(!1), [a, c] = N({}), [s, u] = N({}), f = {
    ...qt,
    ...t
  }, { relay: S, rpcUrl: d, version: v } = f;
  F(() => {
    const E = d ? Dt({ rpcUrl: d }) : Dt(), g = Be({
      relay: S,
      ethereum: E,
      version: v
    });
    r(g);
  }, [S, d, v]);
  const C = R((E) => {
    const { message: g, signature: w, fid: m, username: h, bio: p, displayName: b, pfpUrl: B, custody: A, verifications: M } = E;
    i(!0), c({ fid: m, username: h, bio: p, displayName: b, pfpUrl: B, custody: A, verifications: M }), u({ message: g, signature: w });
  }, []), l = () => {
    i(!1), c({}), u({});
  };
  return /* @__PURE__ */ y(
    Qt.Provider,
    {
      value: {
        appClient: n,
        isAuthenticated: o,
        profile: a,
        signInMessage: s,
        config: f,
        onSignIn: C,
        onSignOut: l
      },
      children: e
    }
  );
}
function q() {
  return Me(Qt);
}
function lt() {
  const { appClient: t } = q();
  return t;
}
function Re({
  nonce: t,
  notBefore: e,
  expirationTime: n,
  requestId: r,
  onSuccess: o,
  onError: i
}) {
  const { config: a } = q(), { siweUri: c, domain: s } = a, u = lt(), [f, S] = N(!1), [d, v] = N(), [C, l] = N(), [E, g] = N(), [w, m] = N(!1), [h, p] = N(!1), [b, B] = N(), A = R(async () => {
    if (f && u && c && s && !d) {
      const k = typeof t == "function" ? await t() : t, {
        data: L,
        isError: mt,
        error: X
      } = await u.createChannel({
        nonce: k,
        siweUri: c,
        domain: s,
        notBefore: e,
        expirationTime: n,
        requestId: r
      });
      if (mt)
        p(!0), B(X), i == null || i(X);
      else {
        const { channelToken: tt, url: Zt, nonce: Ft } = L;
        v(tt), l(Zt), g(Ft), m(!0), o == null || o({ channelToken: tt, url: Zt, nonce: Ft });
      }
    }
  }, [
    f,
    u,
    c,
    s,
    d,
    t,
    e,
    n,
    r,
    i,
    o
  ]);
  F(() => {
    A();
  }, [A]);
  const M = R(async () => {
    S(!0);
  }, [S]), T = R(() => {
    v(void 0), l(void 0), m(!1), p(!1), B(void 0);
  }, [v, l, m, p, B]), Z = R(() => {
    T(), M();
  }, [M, T]);
  return {
    connect: M,
    reconnect: Z,
    reset: T,
    isSuccess: w,
    isError: h,
    error: b,
    data: { channelToken: d, url: C, nonce: E }
  };
}
function ke({
  nonce: t,
  domain: e,
  message: n,
  signature: r,
  onSuccess: o,
  onError: i
}) {
  const a = lt(), [c, s] = N(!1), [u, f] = N(!1), [S, d] = N(!1), [v, C] = N(), l = async () => {
    d(!1), f(!1), s(!1), C(void 0);
  }, E = R(async () => {
    if (a && t && e && n && r) {
      const {
        success: g,
        isError: w,
        error: m
      } = await a.verifySignInMessage({
        nonce: t,
        domain: e,
        message: n,
        signature: r
      });
      w ? (d(!0), C(m), i == null || i(m)) : (s(g), f(!0), o == null || o({ message: n, signature: r, validSignature: g }));
    }
  }, [a, t, e, n, r, o, i]);
  return F(() => {
    l(), t && e && n && r && E();
  }, [t, e, n, r, E]), {
    isSuccess: u,
    isError: S,
    error: v,
    data: { message: n, signature: r, validSignature: c }
  };
}
const Le = {
  timeout: 3e5,
  interval: 1500
};
function _e(t) {
  const e = lt(), { channelToken: n, timeout: r, interval: o, onSuccess: i, onError: a, onResponse: c } = {
    ...Le,
    ...t
  }, [s, u] = N(), [f, S] = N(!1), [d, v] = N(!1), [C, l] = N(!1), [E, g] = N(!1), [w, m] = N(), h = () => {
    u(void 0), S(!1), g(!1), v(!1), m(void 0);
  }, p = () => {
    S(!0);
  }, b = R(async () => {
    if (f && e && n) {
      l(!0);
      const {
        data: B,
        isError: A,
        error: M
      } = await e.watchStatus({
        channelToken: n,
        timeout: r,
        interval: o,
        onResponse: ({ data: T }) => {
          u(T), c == null || c(T);
        }
      });
      A ? (g(!0), l(!1), m(M), a == null || a(M)) : (v(!0), l(!1), u(B), i == null || i(B));
    }
  }, [f, e, n, r, o, i, a, c]);
  return F(() => {
    h(), n && b();
  }, [n, b]), {
    watch: p,
    isSuccess: d,
    isPolling: C,
    isError: E,
    error: w,
    data: s
  };
}
const Ze = {
  timeout: 3e5,
  interval: 1500
};
function Fe(t) {
  const e = lt(), {
    onSignIn: n,
    onSignOut: r,
    config: { domain: o }
  } = q(), { timeout: i, interval: a, onSuccess: c, onStatusResponse: s, onError: u, ...f } = {
    ...Ze,
    ...t
  }, {
    connect: S,
    reconnect: d,
    reset: v,
    data: { channelToken: C, url: l, nonce: E },
    isSuccess: g,
    isError: w,
    error: m
  } = Re({ ...f, onError: u }), {
    watch: h,
    isPolling: p,
    data: b,
    isError: B,
    error: A
  } = _e({
    channelToken: C,
    timeout: i,
    interval: a,
    onError: u,
    onResponse: s
  }), {
    isSuccess: M,
    data: { validSignature: T },
    isError: Z,
    error: k
  } = ke({
    nonce: E,
    domain: o,
    message: b == null ? void 0 : b.message,
    signature: b == null ? void 0 : b.signature,
    onError: u
  }), L = w || B || Z, mt = m || A || k, X = () => {
    h();
  }, tt = () => {
    r(), v();
  };
  return F(() => {
    M && b && T && (n(b), c == null || c(b));
  }, [M, b, T, n, c]), {
    signIn: X,
    signOut: tt,
    connect: S,
    reconnect: d,
    isConnected: g,
    isSuccess: M,
    isPolling: p,
    isError: L,
    error: mt,
    channelToken: C,
    url: l,
    appClient: e,
    data: b,
    validSignature: T
  };
}
function Gt({
  height: t,
  fill: e
}) {
  const n = t * 1.1;
  return /* @__PURE__ */ P(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: n,
      height: t,
      fill: "none",
      children: [
        /* @__PURE__ */ y("title", { children: "Farcaster logo" }),
        /* @__PURE__ */ P("g", { fill: Ut[e], clipPath: "url(#a)", children: [
          /* @__PURE__ */ y("path", { d: "M3.786.05h14.156v2.824h4.025l-.844 2.825h-.714v11.427c.358 0 .65.287.65.642v.77h.13c.358 0 .649.288.649.642v.77h-7.273v-.77c0-.354.29-.642.65-.642h.13v-.77c0-.309.22-.566.512-.628l-.014-6.306c-.23-2.519-2.37-4.493-4.98-4.493-2.608 0-4.75 1.974-4.979 4.494l-.013 6.3c.346.05.772.315.772.633v.77h.13c.358 0 .65.288.65.642v.77H.15v-.77c0-.354.29-.642.649-.642h.13v-.77c0-.355.29-.642.65-.642V5.7H.863L.02 2.874h3.766V.05Z" }),
          /* @__PURE__ */ y("path", { d: "M17.942.05h.047V.003h-.047V.05ZM3.786.05V.003H3.74V.05h.047Zm14.156 2.824h-.048v.047h.048v-.047Zm4.025 0 .046.013.018-.06h-.064v.047Zm-.844 2.824v.047h.035l.01-.033-.045-.014Zm-.714 0v-.046h-.047v.046h.047Zm0 11.428h-.047v.047h.047v-.047Zm.65 1.412h-.048v.047h.047v-.047Zm.779 1.412v.047h.046v-.047h-.046Zm-7.273 0h-.048v.047h.048v-.047Zm.78-1.412v.047h.047v-.047h-.048Zm.512-1.398.01.045.038-.007v-.038h-.048Zm-.014-6.306h.048v-.004l-.048.004Zm-9.959 0-.047-.004v.004h.047Zm-.013 6.3h-.048v.041l.04.006.008-.047Zm.772 1.404h-.047v.047h.047v-.047Zm.78 1.412v.047h.047v-.047h-.048Zm-7.273 0H.102v.047H.15v-.047Zm.779-1.412v.047h.047v-.047H.93Zm.65-1.412v.047h.047v-.047h-.047Zm0-11.428h.047v-.046h-.047v.046Zm-.715 0-.045.014.01.033h.035v-.047ZM.02 2.874v-.047h-.063l.018.06.045-.013Zm3.766 0v.047h.048v-.047h-.048ZM17.942.003H3.786v.093h14.156V.003Zm.047 2.87V.05h-.095v2.824h.095Zm3.978-.046h-4.025v.094h4.025v-.094Zm-.798 2.885.844-2.825-.091-.026-.845 2.824.092.027Zm-.76.033h.714v-.093h-.714v.093Zm.048 11.381V5.698h-.095v11.428h.095Zm.649.641a.693.693 0 0 0-.697-.688v.094c.332 0 .602.266.602.595h.095Zm0 .77v-.77h-.095v.77h.095Zm.082-.045h-.13v.093h.13v-.093Zm.697.688a.692.692 0 0 0-.697-.688v.093c.333 0 .602.267.602.595h.095Zm0 .77v-.77h-.095v.77h.095Zm-3.943.047h3.896v-.094h-3.896v.094Zm-2.079 0h2.079v-.094h-2.079v.094Zm-1.298 0h1.298v-.094h-1.298v.094Zm-.048-.817v.77h.095v-.77h-.095Zm.697-.688a.693.693 0 0 0-.697.688h.095c0-.328.27-.595.602-.595v-.093Zm.13 0h-.13v.093h.13v-.093Zm-.047-.725v.77h.095v-.77h-.095Zm.55-.673a.69.69 0 0 0-.55.673h.095c0-.285.203-.524.476-.582l-.02-.09Zm-.051-6.26.014 6.306h.095l-.014-6.306h-.095Zm-4.932-4.447c2.583 0 4.704 1.956 4.932 4.452l.094-.009c-.232-2.543-2.393-4.536-5.026-4.536v.093ZM5.932 10.84c.227-2.496 2.348-4.452 4.932-4.452v-.093c-2.633 0-4.795 1.993-5.027 4.536l.095.008Zm-.014 6.295.014-6.3h-.095l-.014 6.3h.095Zm.773.633c0-.18-.12-.337-.276-.453a1.236 1.236 0 0 0-.538-.226l-.014.093c.166.025.351.1.495.207.145.108.238.241.238.38h.095Zm0 .77v-.77h-.095v.77h.095Zm.082-.045h-.13v.093h.13v-.093Zm.697.688a.693.693 0 0 0-.697-.688v.093c.332 0 .602.267.602.595h.095Zm0 .77v-.77h-.095v.77h.095Zm-1.606.047h1.558v-.094H5.864v.094Zm-.108 0h.108v-.094h-.108v.094Zm-1.97 0h1.97v-.094h-1.97v.094Zm-3.636 0h3.636v-.094H.15v.094Zm-.048-.817v.77h.095v-.77H.102Zm.697-.688a.693.693 0 0 0-.697.688h.095c0-.328.27-.595.602-.595v-.093Zm.13 0h-.13v.093h.13v-.093Zm-.048-.725v.77h.095v-.77H.881Zm.698-.688a.693.693 0 0 0-.698.688h.095c0-.328.27-.594.603-.594v-.094ZM1.53 5.7v11.427h.095V5.698h-.095Zm-.667.046h.715v-.093H.864v.093Zm-.89-2.858L.82 5.712l.09-.027-.844-2.824-.09.026Zm3.812-.06H.02v.094h3.766v-.094ZM3.74.05v2.824h.095V.05h-.095Z" })
        ] }),
        /* @__PURE__ */ y("defs", { children: /* @__PURE__ */ y("clipPath", { id: "a", children: /* @__PURE__ */ y("path", { fill: Ut[e], d: "M0 0h22v20H0z" }) }) })
      ]
    }
  );
}
const Ut = {
  purple: "#7C65C1",
  white: "#FFFFFF"
};
var De = "_1n3pr301", Ue = "_1n3pr306", Ve = "_1n3pr304", He = "_1n3pr305", xe = "_1n3pr300", Oe = "_1n3pr302", ze = "_1n3pr303";
function bt({ kind: t = "primary", children: e, className: n, ...r }) {
  return /* @__PURE__ */ y("button", { type: "button", className: $e[t] || n, ...r, children: e });
}
const $e = {
  primary: De,
  secondary: Oe,
  tertiary: ze,
  reset: xe
};
function Ke({
  label: t,
  onClick: e
}) {
  return /* @__PURE__ */ P(bt, { kind: "primary", onClick: e, children: [
    /* @__PURE__ */ y(Gt, { height: 20, fill: "white" }),
    /* @__PURE__ */ y("span", { style: { marginLeft: 9 }, children: t })
  ] });
}
var Xt = "_1n3pr302";
function Ye(t, e) {
  F(() => {
    function n(r) {
      t.current && !t.current.contains(r.target) && e();
    }
    return document.addEventListener("mousedown", n), () => {
      document.removeEventListener("mousedown", n);
    };
  }, [t, e]);
}
var We = "_1rbg3ua1", je = "_1rbg3ua2", Je = "_1rbg3ua3";
var qe = "_16wbil70", Qe = "_16wbil71";
function Ge({ signOut: t }) {
  return /* @__PURE__ */ y("div", { className: qe, children: /* @__PURE__ */ P(
    "button",
    {
      type: "button",
      className: Xt,
      style: {
        boxShadow: "0px 6px 12px 0 rgba(0,0,0,0.12)"
      },
      onClick: t,
      children: [
        /* @__PURE__ */ P(
          "svg",
          {
            width: "19",
            height: "20",
            viewBox: "0 0 19 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: Qe,
            children: [
              /* @__PURE__ */ y("title", { children: "Sign Out" }),
              /* @__PURE__ */ y(
                "path",
                {
                  d: "M11.75 7V3.25C11.75 2.65326 11.5129 2.08097 11.091 1.65901C10.669 1.23705 10.0967 1 9.5 1H3.5C2.90326 1 2.33097 1.23705 1.90901 1.65901C1.48705 2.08097 1.25 2.65326 1.25 3.25V16.75C1.25 17.3467 1.48705 17.919 1.90901 18.341C2.33097 18.7629 2.90326 19 3.5 19H9.5C10.0967 19 10.669 18.7629 11.091 18.341C11.5129 17.919 11.75 17.3467 11.75 16.75V13M14.75 13L17.75 10M17.75 10L14.75 7M17.75 10H5",
                  stroke: "black",
                  strokeWidth: "1.5",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              )
            ]
          }
        ),
        "Sign out"
      ]
    }
  ) });
}
function Xe({
  userData: t,
  signOut: e,
  hideSignOut: n
}) {
  const [r, o] = N(!1), i = Jt(null);
  Ye(i, () => o(!1));
  const a = (t == null ? void 0 : t.username) ?? `!${t == null ? void 0 : t.fid}`, c = (t == null ? void 0 : t.pfpUrl) ?? "https://warpcast.com/avatar.png", s = r && !n;
  return /* @__PURE__ */ y(
    "div",
    {
      className: `fc-authkit-profile-button ${We}`,
      ref: i,
      children: /* @__PURE__ */ P(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end"
          },
          children: [
            /* @__PURE__ */ P(
              "button",
              {
                type: "button",
                className: Xt,
                onClick: () => o(!r),
                children: [
                  /* @__PURE__ */ y("img", { className: je, src: c, alt: "avatar" }),
                  /* @__PURE__ */ y("span", { className: Je, children: a }),
                  !n && /* @__PURE__ */ P(
                    "svg",
                    {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: [
                        /* @__PURE__ */ y("title", { children: "Dropdown" }),
                        /* @__PURE__ */ y("g", { opacity: "0.5", children: /* @__PURE__ */ y(
                          "path",
                          {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M6.26418 9.864C6.43293 9.69545 6.66168 9.60079 6.90018 9.60079C7.13869 9.60079 7.36743 9.69545 7.53618 9.864L12.0002 14.328L16.4642 9.864C16.5466 9.77557 16.6459 9.70465 16.7563 9.65546C16.8667 9.60627 16.9859 9.57982 17.1068 9.57769C17.2276 9.57555 17.3476 9.59778 17.4597 9.64305C17.5718 9.68831 17.6736 9.75569 17.759 9.84115C17.8445 9.92661 17.9119 10.0284 17.9571 10.1405C18.0024 10.2525 18.0246 10.3726 18.0225 10.4934C18.0204 10.6143 17.9939 10.7334 17.9447 10.8438C17.8955 10.9542 17.8246 11.0536 17.7362 11.136L12.6362 16.236C12.4674 16.4045 12.2387 16.4992 12.0002 16.4992C11.7617 16.4992 11.5329 16.4045 11.3642 16.236L6.26418 11.136C6.09564 10.9672 6.00098 10.7385 6.00098 10.5C6.00098 10.2615 6.09564 10.0327 6.26418 9.864Z",
                            fill: "black"
                          }
                        ) })
                      ]
                    }
                  )
                ]
              }
            ),
            s && /* @__PURE__ */ y(Ge, { signOut: e })
          ]
        }
      )
    }
  );
}
var D = function() {
  return D = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, D.apply(this, arguments);
};
function te(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function tn(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = e.length, i; r < o; r++)
      (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var it = "right-scroll-bar-position", at = "width-before-scroll-bar", en = "with-scroll-bars-hidden", nn = "--removed-body-scroll-bar-size";
function rn(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function on(t, e) {
  var n = N(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
function an(t, e) {
  return on(e || null, function(n) {
    return t.forEach(function(r) {
      return rn(r, n);
    });
  });
}
function cn(t) {
  return t;
}
function sn(t, e) {
  e === void 0 && (e = cn);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(i) {
      var a = e(i, r);
      return n.push(a), function() {
        n = n.filter(function(c) {
          return c !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), a = n;
      }
      var s = function() {
        var f = a;
        a = [], f.forEach(i);
      }, u = function() {
        return Promise.resolve().then(s);
      };
      u(), n = {
        push: function(f) {
          a.push(f), u();
        },
        filter: function(f) {
          return a = a.filter(f), n;
        }
      };
    }
  };
  return o;
}
function ln(t) {
  t === void 0 && (t = {});
  var e = sn(null);
  return e.options = D({ async: !0, ssr: !1 }, t), e;
}
var ee = function(t) {
  var e = t.sideCar, n = te(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return I.createElement(r, D({}, n));
};
ee.isSideCarExport = !0;
function un(t, e) {
  return t.useMedium(e), ee;
}
var ne = ln(), vt = function() {
}, ut = I.forwardRef(function(t, e) {
  var n = I.useRef(null), r = I.useState({
    onScrollCapture: vt,
    onWheelCapture: vt,
    onTouchMoveCapture: vt
  }), o = r[0], i = r[1], a = t.forwardProps, c = t.children, s = t.className, u = t.removeScrollBar, f = t.enabled, S = t.shards, d = t.sideCar, v = t.noIsolation, C = t.inert, l = t.allowPinchZoom, E = t.as, g = E === void 0 ? "div" : E, w = t.gapMode, m = te(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), h = d, p = an([n, e]), b = D(D({}, m), o);
  return I.createElement(
    I.Fragment,
    null,
    f && I.createElement(h, { sideCar: ne, removeScrollBar: u, shards: S, noIsolation: v, inert: C, setCallbacks: i, allowPinchZoom: !!l, lockRef: n, gapMode: w }),
    a ? I.cloneElement(I.Children.only(c), D(D({}, b), { ref: p })) : I.createElement(g, D({}, b, { className: s, ref: p }), c)
  );
});
ut.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ut.classNames = {
  fullWidth: at,
  zeroRight: it
};
var Vt, fn = function() {
  if (Vt)
    return Vt;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function dn() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = fn();
  return e && t.setAttribute("nonce", e), t;
}
function hn(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function gn(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var mn = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = dn()) && (hn(e, n), gn(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, vn = function() {
  var t = mn();
  return function(e, n) {
    I.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, re = function() {
  var t = vn(), e = function(n) {
    var r = n.styles, o = n.dynamic;
    return t(r, o), null;
  };
  return e;
}, wn = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, wt = function(t) {
  return parseInt(t || "", 10) || 0;
}, pn = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], o = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [wt(n), wt(r), wt(o)];
}, yn = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return wn;
  var e = pn(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, Cn = re(), En = function(t, e, n, r) {
  var o = t.left, i = t.top, a = t.right, c = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(en, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(it, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(at, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(it, " .").concat(it, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(at, " .").concat(at, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(nn, ": ").concat(c, `px;
  }
`);
}, Sn = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, o = r === void 0 ? "margin" : r, i = I.useMemo(function() {
    return yn(o);
  }, [o]);
  return I.createElement(Cn, { styles: En(i, !e, o, n ? "" : "!important") });
}, Bt = !1;
if (typeof window < "u")
  try {
    var et = Object.defineProperty({}, "passive", {
      get: function() {
        return Bt = !0, !0;
      }
    });
    window.addEventListener("test", et, et), window.removeEventListener("test", et, et);
  } catch {
    Bt = !1;
  }
var x = Bt ? { passive: !1 } : !1, bn = function(t) {
  return t.tagName === "TEXTAREA";
}, oe = function(t, e) {
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !bn(t) && n[e] === "visible")
  );
}, Bn = function(t) {
  return oe(t, "overflowY");
}, In = function(t) {
  return oe(t, "overflowX");
}, Ht = function(t, e) {
  var n = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = ie(t, r);
    if (o) {
      var i = ae(t, r), a = i[1], c = i[2];
      if (a > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Mn = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, An = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, ie = function(t, e) {
  return t === "v" ? Bn(e) : In(e);
}, ae = function(t, e) {
  return t === "v" ? Mn(e) : An(e);
}, Nn = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, Pn = function(t, e, n, r, o) {
  var i = Nn(t, window.getComputedStyle(e).direction), a = i * r, c = n.target, s = e.contains(c), u = !1, f = a > 0, S = 0, d = 0;
  do {
    var v = ae(t, c), C = v[0], l = v[1], E = v[2], g = l - E - i * C;
    (C || g) && ie(t, c) && (S += g, d += C), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !s && c !== document.body || // self content
    s && (e.contains(c) || e === c)
  );
  return (f && (o && Math.abs(S) < 1 || !o && a > S) || !f && (o && Math.abs(d) < 1 || !o && -a > d)) && (u = !0), u;
}, nt = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, xt = function(t) {
  return [t.deltaX, t.deltaY];
}, Ot = function(t) {
  return t && "current" in t ? t.current : t;
}, Tn = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, Rn = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, kn = 0, O = [];
function Ln(t) {
  var e = I.useRef([]), n = I.useRef([0, 0]), r = I.useRef(), o = I.useState(kn++)[0], i = I.useState(re)[0], a = I.useRef(t);
  I.useEffect(function() {
    a.current = t;
  }, [t]), I.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var l = tn([t.lockRef.current], (t.shards || []).map(Ot), !0).filter(Boolean);
      return l.forEach(function(E) {
        return E.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), l.forEach(function(E) {
          return E.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var c = I.useCallback(function(l, E) {
    if ("touches" in l && l.touches.length === 2)
      return !a.current.allowPinchZoom;
    var g = nt(l), w = n.current, m = "deltaX" in l ? l.deltaX : w[0] - g[0], h = "deltaY" in l ? l.deltaY : w[1] - g[1], p, b = l.target, B = Math.abs(m) > Math.abs(h) ? "h" : "v";
    if ("touches" in l && B === "h" && b.type === "range")
      return !1;
    var A = Ht(B, b);
    if (!A)
      return !0;
    if (A ? p = B : (p = B === "v" ? "h" : "v", A = Ht(B, b)), !A)
      return !1;
    if (!r.current && "changedTouches" in l && (m || h) && (r.current = p), !p)
      return !0;
    var M = r.current || p;
    return Pn(M, E, l, M === "h" ? m : h, !0);
  }, []), s = I.useCallback(function(l) {
    var E = l;
    if (!(!O.length || O[O.length - 1] !== i)) {
      var g = "deltaY" in E ? xt(E) : nt(E), w = e.current.filter(function(p) {
        return p.name === E.type && (p.target === E.target || E.target === p.shadowParent) && Tn(p.delta, g);
      })[0];
      if (w && w.should) {
        E.cancelable && E.preventDefault();
        return;
      }
      if (!w) {
        var m = (a.current.shards || []).map(Ot).filter(Boolean).filter(function(p) {
          return p.contains(E.target);
        }), h = m.length > 0 ? c(E, m[0]) : !a.current.noIsolation;
        h && E.cancelable && E.preventDefault();
      }
    }
  }, []), u = I.useCallback(function(l, E, g, w) {
    var m = { name: l, delta: E, target: g, should: w, shadowParent: _n(g) };
    e.current.push(m), setTimeout(function() {
      e.current = e.current.filter(function(h) {
        return h !== m;
      });
    }, 1);
  }, []), f = I.useCallback(function(l) {
    n.current = nt(l), r.current = void 0;
  }, []), S = I.useCallback(function(l) {
    u(l.type, xt(l), l.target, c(l, t.lockRef.current));
  }, []), d = I.useCallback(function(l) {
    u(l.type, nt(l), l.target, c(l, t.lockRef.current));
  }, []);
  I.useEffect(function() {
    return O.push(i), t.setCallbacks({
      onScrollCapture: S,
      onWheelCapture: S,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", s, x), document.addEventListener("touchmove", s, x), document.addEventListener("touchstart", f, x), function() {
      O = O.filter(function(l) {
        return l !== i;
      }), document.removeEventListener("wheel", s, x), document.removeEventListener("touchmove", s, x), document.removeEventListener("touchstart", f, x);
    };
  }, []);
  var v = t.removeScrollBar, C = t.inert;
  return I.createElement(
    I.Fragment,
    null,
    C ? I.createElement(i, { styles: Rn(o) }) : null,
    v ? I.createElement(Sn, { gapMode: t.gapMode }) : null
  );
}
function _n(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const Zn = un(ne, Ln);
var ce = I.forwardRef(function(t, e) {
  return I.createElement(ut, D({}, t, { ref: e, sideCar: Zn }));
});
ce.classNames = ut.classNames;
const Fn = ce;
var Dn = "nao3n43", Un = "nao3n42";
const zt = (t, e) => {
  const n = t.querySelectorAll("button:not(:disabled), a[href]");
  n.length !== 0 && n[e === "end" ? n.length - 1 : 0].focus();
};
function Vn(t) {
  const e = Jt(null);
  return F(() => {
    const n = document.activeElement;
    return () => {
      var r;
      (r = n.focus) == null || r.call(n);
    };
  }, []), F(() => {
    if (e.current) {
      const n = e.current.querySelector("[data-auto-focus]");
      n ? n.focus() : e.current.focus();
    }
  }, []), /* @__PURE__ */ P(j, { children: [
    /* @__PURE__ */ y(
      "div",
      {
        onFocus: R(() => e.current && zt(e.current, "end"), []),
        tabIndex: 0
      }
    ),
    /* @__PURE__ */ y("div", { ref: e, style: { outline: "none" }, tabIndex: -1, ...t }),
    /* @__PURE__ */ y(
      "div",
      {
        onFocus: R(() => e.current && zt(e.current, "start"), []),
        tabIndex: 0
      }
    )
  ] });
}
function Hn() {
  return typeof navigator < "u" && /android/i.test(navigator.userAgent);
}
function xn() {
  return typeof navigator < "u" && /iPhone|iPod/.test(navigator.userAgent);
}
function On() {
  return typeof navigator < "u" && (/iPad/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}
function zn() {
  return xn() || On();
}
function It() {
  return Hn() || zn();
}
const $n = (t) => t.stopPropagation();
function Kn({ children: t, onClose: e, open: n, titleId: r }) {
  F(() => {
    const c = (s) => n && s.key === "Escape" && e();
    return document.addEventListener("keydown", c), () => document.removeEventListener("keydown", c);
  }, [n, e]);
  const [o, i] = N(!0);
  F(() => {
    i(
      getComputedStyle(window.document.body).overflow !== "hidden"
    );
  }, []);
  const a = R(() => e(), [e]);
  return /* @__PURE__ */ y(j, { children: n ? Ne(
    /* @__PURE__ */ y(Fn, { enabled: o, children: /* @__PURE__ */ y(
      "div",
      {
        style: {
          alignItems: It() ? "flex-end" : "center",
          position: "fixed"
        },
        "aria-labelledby": r,
        "aria-modal": !0,
        className: Un,
        onClick: a,
        role: "dialog",
        children: /* @__PURE__ */ y(
          Vn,
          {
            className: Dn,
            onClick: $n,
            role: "document",
            children: t
          }
        )
      }
    ) }),
    document.body
  ) : null });
}
var Yn = "_1sj0tk80", $t = "_1sj0tk82", Kt = "_1sj0tk81", Q = {}, Wn = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, se = {}, _ = {};
let Tt;
const jn = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
_.getSymbolSize = function(e) {
  if (!e)
    throw new Error('"version" cannot be null or undefined');
  if (e < 1 || e > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return e * 4 + 17;
};
_.getSymbolTotalCodewords = function(e) {
  return jn[e];
};
_.getBCHDigit = function(t) {
  let e = 0;
  for (; t !== 0; )
    e++, t >>>= 1;
  return e;
};
_.setToSJISFunction = function(e) {
  if (typeof e != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  Tt = e;
};
_.isKanjiModeEnabled = function() {
  return typeof Tt < "u";
};
_.toSJIS = function(e) {
  return Tt(e);
};
var ft = {};
(function(t) {
  t.L = { bit: 1 }, t.M = { bit: 0 }, t.Q = { bit: 3 }, t.H = { bit: 2 };
  function e(n) {
    if (typeof n != "string")
      throw new Error("Param is not a string");
    switch (n.toLowerCase()) {
      case "l":
      case "low":
        return t.L;
      case "m":
      case "medium":
        return t.M;
      case "q":
      case "quartile":
        return t.Q;
      case "h":
      case "high":
        return t.H;
      default:
        throw new Error("Unknown EC Level: " + n);
    }
  }
  t.isValid = function(r) {
    return r && typeof r.bit < "u" && r.bit >= 0 && r.bit < 4;
  }, t.from = function(r, o) {
    if (t.isValid(r))
      return r;
    try {
      return e(r);
    } catch {
      return o;
    }
  };
})(ft);
function le() {
  this.buffer = [], this.length = 0;
}
le.prototype = {
  get: function(t) {
    const e = Math.floor(t / 8);
    return (this.buffer[e] >>> 7 - t % 8 & 1) === 1;
  },
  put: function(t, e) {
    for (let n = 0; n < e; n++)
      this.putBit((t >>> e - n - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(t) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var Jn = le;
function G(t) {
  if (!t || t < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
}
G.prototype.set = function(t, e, n, r) {
  const o = t * this.size + e;
  this.data[o] = n, r && (this.reservedBit[o] = !0);
};
G.prototype.get = function(t, e) {
  return this.data[t * this.size + e];
};
G.prototype.xor = function(t, e, n) {
  this.data[t * this.size + e] ^= n;
};
G.prototype.isReserved = function(t, e) {
  return this.reservedBit[t * this.size + e];
};
var qn = G, ue = {};
(function(t) {
  const e = _.getSymbolSize;
  t.getRowColCoords = function(r) {
    if (r === 1)
      return [];
    const o = Math.floor(r / 7) + 2, i = e(r), a = i === 145 ? 26 : Math.ceil((i - 13) / (2 * o - 2)) * 2, c = [i - 7];
    for (let s = 1; s < o - 1; s++)
      c[s] = c[s - 1] - a;
    return c.push(6), c.reverse();
  }, t.getPositions = function(r) {
    const o = [], i = t.getRowColCoords(r), a = i.length;
    for (let c = 0; c < a; c++)
      for (let s = 0; s < a; s++)
        c === 0 && s === 0 || // top-left
        c === 0 && s === a - 1 || // bottom-left
        c === a - 1 && s === 0 || o.push([i[c], i[s]]);
    return o;
  };
})(ue);
var fe = {};
const Qn = _.getSymbolSize, Yt = 7;
fe.getPositions = function(e) {
  const n = Qn(e);
  return [
    // top-left
    [0, 0],
    // top-right
    [n - Yt, 0],
    // bottom-left
    [0, n - Yt]
  ];
};
var de = {};
(function(t) {
  t.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const e = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  t.isValid = function(o) {
    return o != null && o !== "" && !isNaN(o) && o >= 0 && o <= 7;
  }, t.from = function(o) {
    return t.isValid(o) ? parseInt(o, 10) : void 0;
  }, t.getPenaltyN1 = function(o) {
    const i = o.size;
    let a = 0, c = 0, s = 0, u = null, f = null;
    for (let S = 0; S < i; S++) {
      c = s = 0, u = f = null;
      for (let d = 0; d < i; d++) {
        let v = o.get(S, d);
        v === u ? c++ : (c >= 5 && (a += e.N1 + (c - 5)), u = v, c = 1), v = o.get(d, S), v === f ? s++ : (s >= 5 && (a += e.N1 + (s - 5)), f = v, s = 1);
      }
      c >= 5 && (a += e.N1 + (c - 5)), s >= 5 && (a += e.N1 + (s - 5));
    }
    return a;
  }, t.getPenaltyN2 = function(o) {
    const i = o.size;
    let a = 0;
    for (let c = 0; c < i - 1; c++)
      for (let s = 0; s < i - 1; s++) {
        const u = o.get(c, s) + o.get(c, s + 1) + o.get(c + 1, s) + o.get(c + 1, s + 1);
        (u === 4 || u === 0) && a++;
      }
    return a * e.N2;
  }, t.getPenaltyN3 = function(o) {
    const i = o.size;
    let a = 0, c = 0, s = 0;
    for (let u = 0; u < i; u++) {
      c = s = 0;
      for (let f = 0; f < i; f++)
        c = c << 1 & 2047 | o.get(u, f), f >= 10 && (c === 1488 || c === 93) && a++, s = s << 1 & 2047 | o.get(f, u), f >= 10 && (s === 1488 || s === 93) && a++;
    }
    return a * e.N3;
  }, t.getPenaltyN4 = function(o) {
    let i = 0;
    const a = o.data.length;
    for (let s = 0; s < a; s++)
      i += o.data[s];
    return Math.abs(Math.ceil(i * 100 / a / 5) - 10) * e.N4;
  };
  function n(r, o, i) {
    switch (r) {
      case t.Patterns.PATTERN000:
        return (o + i) % 2 === 0;
      case t.Patterns.PATTERN001:
        return o % 2 === 0;
      case t.Patterns.PATTERN010:
        return i % 3 === 0;
      case t.Patterns.PATTERN011:
        return (o + i) % 3 === 0;
      case t.Patterns.PATTERN100:
        return (Math.floor(o / 2) + Math.floor(i / 3)) % 2 === 0;
      case t.Patterns.PATTERN101:
        return o * i % 2 + o * i % 3 === 0;
      case t.Patterns.PATTERN110:
        return (o * i % 2 + o * i % 3) % 2 === 0;
      case t.Patterns.PATTERN111:
        return (o * i % 3 + (o + i) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + r);
    }
  }
  t.applyMask = function(o, i) {
    const a = i.size;
    for (let c = 0; c < a; c++)
      for (let s = 0; s < a; s++)
        i.isReserved(s, c) || i.xor(s, c, n(o, s, c));
  }, t.getBestMask = function(o, i) {
    const a = Object.keys(t.Patterns).length;
    let c = 0, s = 1 / 0;
    for (let u = 0; u < a; u++) {
      i(u), t.applyMask(u, o);
      const f = t.getPenaltyN1(o) + t.getPenaltyN2(o) + t.getPenaltyN3(o) + t.getPenaltyN4(o);
      t.applyMask(u, o), f < s && (s = f, c = u);
    }
    return c;
  };
})(de);
var dt = {};
const V = ft, rt = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], ot = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
dt.getBlocksCount = function(e, n) {
  switch (n) {
    case V.L:
      return rt[(e - 1) * 4 + 0];
    case V.M:
      return rt[(e - 1) * 4 + 1];
    case V.Q:
      return rt[(e - 1) * 4 + 2];
    case V.H:
      return rt[(e - 1) * 4 + 3];
    default:
      return;
  }
};
dt.getTotalCodewordsCount = function(e, n) {
  switch (n) {
    case V.L:
      return ot[(e - 1) * 4 + 0];
    case V.M:
      return ot[(e - 1) * 4 + 1];
    case V.Q:
      return ot[(e - 1) * 4 + 2];
    case V.H:
      return ot[(e - 1) * 4 + 3];
    default:
      return;
  }
};
var he = {}, ht = {};
const W = new Uint8Array(512), ct = new Uint8Array(256);
(function() {
  let e = 1;
  for (let n = 0; n < 255; n++)
    W[n] = e, ct[e] = n, e <<= 1, e & 256 && (e ^= 285);
  for (let n = 255; n < 512; n++)
    W[n] = W[n - 255];
})();
ht.log = function(e) {
  if (e < 1)
    throw new Error("log(" + e + ")");
  return ct[e];
};
ht.exp = function(e) {
  return W[e];
};
ht.mul = function(e, n) {
  return e === 0 || n === 0 ? 0 : W[ct[e] + ct[n]];
};
(function(t) {
  const e = ht;
  t.mul = function(r, o) {
    const i = new Uint8Array(r.length + o.length - 1);
    for (let a = 0; a < r.length; a++)
      for (let c = 0; c < o.length; c++)
        i[a + c] ^= e.mul(r[a], o[c]);
    return i;
  }, t.mod = function(r, o) {
    let i = new Uint8Array(r);
    for (; i.length - o.length >= 0; ) {
      const a = i[0];
      for (let s = 0; s < o.length; s++)
        i[s] ^= e.mul(o[s], a);
      let c = 0;
      for (; c < i.length && i[c] === 0; )
        c++;
      i = i.slice(c);
    }
    return i;
  }, t.generateECPolynomial = function(r) {
    let o = new Uint8Array([1]);
    for (let i = 0; i < r; i++)
      o = t.mul(o, new Uint8Array([1, e.exp(i)]));
    return o;
  };
})(he);
const ge = he;
function Rt(t) {
  this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
}
Rt.prototype.initialize = function(e) {
  this.degree = e, this.genPoly = ge.generateECPolynomial(this.degree);
};
Rt.prototype.encode = function(e) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const n = new Uint8Array(e.length + this.degree);
  n.set(e);
  const r = ge.mod(n, this.genPoly), o = this.degree - r.length;
  if (o > 0) {
    const i = new Uint8Array(this.degree);
    return i.set(r, o), i;
  }
  return r;
};
var Gn = Rt, me = {}, H = {}, kt = {};
kt.isValid = function(e) {
  return !isNaN(e) && e >= 1 && e <= 40;
};
var U = {};
const ve = "[0-9]+", Xn = "[A-Z $%*+\\-./:]+";
let J = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
J = J.replace(/u/g, "\\u");
const tr = "(?:(?![A-Z0-9 $%*+\\-./:]|" + J + `)(?:.|[\r
]))+`;
U.KANJI = new RegExp(J, "g");
U.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
U.BYTE = new RegExp(tr, "g");
U.NUMERIC = new RegExp(ve, "g");
U.ALPHANUMERIC = new RegExp(Xn, "g");
const er = new RegExp("^" + J + "$"), nr = new RegExp("^" + ve + "$"), rr = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
U.testKanji = function(e) {
  return er.test(e);
};
U.testNumeric = function(e) {
  return nr.test(e);
};
U.testAlphanumeric = function(e) {
  return rr.test(e);
};
(function(t) {
  const e = kt, n = U;
  t.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, t.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, t.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, t.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, t.MIXED = {
    bit: -1
  }, t.getCharCountIndicator = function(i, a) {
    if (!i.ccBits)
      throw new Error("Invalid mode: " + i);
    if (!e.isValid(a))
      throw new Error("Invalid version: " + a);
    return a >= 1 && a < 10 ? i.ccBits[0] : a < 27 ? i.ccBits[1] : i.ccBits[2];
  }, t.getBestModeForData = function(i) {
    return n.testNumeric(i) ? t.NUMERIC : n.testAlphanumeric(i) ? t.ALPHANUMERIC : n.testKanji(i) ? t.KANJI : t.BYTE;
  }, t.toString = function(i) {
    if (i && i.id)
      return i.id;
    throw new Error("Invalid mode");
  }, t.isValid = function(i) {
    return i && i.bit && i.ccBits;
  };
  function r(o) {
    if (typeof o != "string")
      throw new Error("Param is not a string");
    switch (o.toLowerCase()) {
      case "numeric":
        return t.NUMERIC;
      case "alphanumeric":
        return t.ALPHANUMERIC;
      case "kanji":
        return t.KANJI;
      case "byte":
        return t.BYTE;
      default:
        throw new Error("Unknown mode: " + o);
    }
  }
  t.from = function(i, a) {
    if (t.isValid(i))
      return i;
    try {
      return r(i);
    } catch {
      return a;
    }
  };
})(H);
(function(t) {
  const e = _, n = dt, r = ft, o = H, i = kt, a = 7973, c = e.getBCHDigit(a);
  function s(d, v, C) {
    for (let l = 1; l <= 40; l++)
      if (v <= t.getCapacity(l, C, d))
        return l;
  }
  function u(d, v) {
    return o.getCharCountIndicator(d, v) + 4;
  }
  function f(d, v) {
    let C = 0;
    return d.forEach(function(l) {
      const E = u(l.mode, v);
      C += E + l.getBitsLength();
    }), C;
  }
  function S(d, v) {
    for (let C = 1; C <= 40; C++)
      if (f(d, C) <= t.getCapacity(C, v, o.MIXED))
        return C;
  }
  t.from = function(v, C) {
    return i.isValid(v) ? parseInt(v, 10) : C;
  }, t.getCapacity = function(v, C, l) {
    if (!i.isValid(v))
      throw new Error("Invalid QR Code version");
    typeof l > "u" && (l = o.BYTE);
    const E = e.getSymbolTotalCodewords(v), g = n.getTotalCodewordsCount(v, C), w = (E - g) * 8;
    if (l === o.MIXED)
      return w;
    const m = w - u(l, v);
    switch (l) {
      case o.NUMERIC:
        return Math.floor(m / 10 * 3);
      case o.ALPHANUMERIC:
        return Math.floor(m / 11 * 2);
      case o.KANJI:
        return Math.floor(m / 13);
      case o.BYTE:
      default:
        return Math.floor(m / 8);
    }
  }, t.getBestVersionForData = function(v, C) {
    let l;
    const E = r.from(C, r.M);
    if (Array.isArray(v)) {
      if (v.length > 1)
        return S(v, E);
      if (v.length === 0)
        return 1;
      l = v[0];
    } else
      l = v;
    return s(l.mode, l.getLength(), E);
  }, t.getEncodedBits = function(v) {
    if (!i.isValid(v) || v < 7)
      throw new Error("Invalid QR Code version");
    let C = v << 12;
    for (; e.getBCHDigit(C) - c >= 0; )
      C ^= a << e.getBCHDigit(C) - c;
    return v << 12 | C;
  };
})(me);
var we = {};
const Mt = _, pe = 1335, or = 21522, Wt = Mt.getBCHDigit(pe);
we.getEncodedBits = function(e, n) {
  const r = e.bit << 3 | n;
  let o = r << 10;
  for (; Mt.getBCHDigit(o) - Wt >= 0; )
    o ^= pe << Mt.getBCHDigit(o) - Wt;
  return (r << 10 | o) ^ or;
};
var ye = {};
const ir = H;
function z(t) {
  this.mode = ir.NUMERIC, this.data = t.toString();
}
z.getBitsLength = function(e) {
  return 10 * Math.floor(e / 3) + (e % 3 ? e % 3 * 3 + 1 : 0);
};
z.prototype.getLength = function() {
  return this.data.length;
};
z.prototype.getBitsLength = function() {
  return z.getBitsLength(this.data.length);
};
z.prototype.write = function(e) {
  let n, r, o;
  for (n = 0; n + 3 <= this.data.length; n += 3)
    r = this.data.substr(n, 3), o = parseInt(r, 10), e.put(o, 10);
  const i = this.data.length - n;
  i > 0 && (r = this.data.substr(n), o = parseInt(r, 10), e.put(o, i * 3 + 1));
};
var ar = z;
const cr = H, pt = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function $(t) {
  this.mode = cr.ALPHANUMERIC, this.data = t;
}
$.getBitsLength = function(e) {
  return 11 * Math.floor(e / 2) + 6 * (e % 2);
};
$.prototype.getLength = function() {
  return this.data.length;
};
$.prototype.getBitsLength = function() {
  return $.getBitsLength(this.data.length);
};
$.prototype.write = function(e) {
  let n;
  for (n = 0; n + 2 <= this.data.length; n += 2) {
    let r = pt.indexOf(this.data[n]) * 45;
    r += pt.indexOf(this.data[n + 1]), e.put(r, 11);
  }
  this.data.length % 2 && e.put(pt.indexOf(this.data[n]), 6);
};
var sr = $, lr = function(e) {
  for (var n = [], r = e.length, o = 0; o < r; o++) {
    var i = e.charCodeAt(o);
    if (i >= 55296 && i <= 56319 && r > o + 1) {
      var a = e.charCodeAt(o + 1);
      a >= 56320 && a <= 57343 && (i = (i - 55296) * 1024 + a - 56320 + 65536, o += 1);
    }
    if (i < 128) {
      n.push(i);
      continue;
    }
    if (i < 2048) {
      n.push(i >> 6 | 192), n.push(i & 63 | 128);
      continue;
    }
    if (i < 55296 || i >= 57344 && i < 65536) {
      n.push(i >> 12 | 224), n.push(i >> 6 & 63 | 128), n.push(i & 63 | 128);
      continue;
    }
    if (i >= 65536 && i <= 1114111) {
      n.push(i >> 18 | 240), n.push(i >> 12 & 63 | 128), n.push(i >> 6 & 63 | 128), n.push(i & 63 | 128);
      continue;
    }
    n.push(239, 191, 189);
  }
  return new Uint8Array(n).buffer;
};
const ur = lr, fr = H;
function K(t) {
  this.mode = fr.BYTE, typeof t == "string" && (t = ur(t)), this.data = new Uint8Array(t);
}
K.getBitsLength = function(e) {
  return e * 8;
};
K.prototype.getLength = function() {
  return this.data.length;
};
K.prototype.getBitsLength = function() {
  return K.getBitsLength(this.data.length);
};
K.prototype.write = function(t) {
  for (let e = 0, n = this.data.length; e < n; e++)
    t.put(this.data[e], 8);
};
var dr = K;
const hr = H, gr = _;
function Y(t) {
  this.mode = hr.KANJI, this.data = t;
}
Y.getBitsLength = function(e) {
  return e * 13;
};
Y.prototype.getLength = function() {
  return this.data.length;
};
Y.prototype.getBitsLength = function() {
  return Y.getBitsLength(this.data.length);
};
Y.prototype.write = function(t) {
  let e;
  for (e = 0; e < this.data.length; e++) {
    let n = gr.toSJIS(this.data[e]);
    if (n >= 33088 && n <= 40956)
      n -= 33088;
    else if (n >= 57408 && n <= 60351)
      n -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[e] + `
Make sure your charset is UTF-8`
      );
    n = (n >>> 8 & 255) * 192 + (n & 255), t.put(n, 13);
  }
};
var mr = Y, Ce = { exports: {} };
(function(t) {
  var e = {
    single_source_shortest_paths: function(n, r, o) {
      var i = {}, a = {};
      a[r] = 0;
      var c = e.PriorityQueue.make();
      c.push(r, 0);
      for (var s, u, f, S, d, v, C, l, E; !c.empty(); ) {
        s = c.pop(), u = s.value, S = s.cost, d = n[u] || {};
        for (f in d)
          d.hasOwnProperty(f) && (v = d[f], C = S + v, l = a[f], E = typeof a[f] > "u", (E || l > C) && (a[f] = C, c.push(f, C), i[f] = u));
      }
      if (typeof o < "u" && typeof a[o] > "u") {
        var g = ["Could not find a path from ", r, " to ", o, "."].join("");
        throw new Error(g);
      }
      return i;
    },
    extract_shortest_path_from_predecessor_list: function(n, r) {
      for (var o = [], i = r; i; )
        o.push(i), n[i], i = n[i];
      return o.reverse(), o;
    },
    find_path: function(n, r, o) {
      var i = e.single_source_shortest_paths(n, r, o);
      return e.extract_shortest_path_from_predecessor_list(
        i,
        o
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(n) {
        var r = e.PriorityQueue, o = {}, i;
        n = n || {};
        for (i in r)
          r.hasOwnProperty(i) && (o[i] = r[i]);
        return o.queue = [], o.sorter = n.sorter || r.default_sorter, o;
      },
      default_sorter: function(n, r) {
        return n.cost - r.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(n, r) {
        var o = { value: n, cost: r };
        this.queue.push(o), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  t.exports = e;
})(Ce);
var vr = Ce.exports;
(function(t) {
  const e = H, n = ar, r = sr, o = dr, i = mr, a = U, c = _, s = vr;
  function u(g) {
    return unescape(encodeURIComponent(g)).length;
  }
  function f(g, w, m) {
    const h = [];
    let p;
    for (; (p = g.exec(m)) !== null; )
      h.push({
        data: p[0],
        index: p.index,
        mode: w,
        length: p[0].length
      });
    return h;
  }
  function S(g) {
    const w = f(a.NUMERIC, e.NUMERIC, g), m = f(a.ALPHANUMERIC, e.ALPHANUMERIC, g);
    let h, p;
    return c.isKanjiModeEnabled() ? (h = f(a.BYTE, e.BYTE, g), p = f(a.KANJI, e.KANJI, g)) : (h = f(a.BYTE_KANJI, e.BYTE, g), p = []), w.concat(m, h, p).sort(function(B, A) {
      return B.index - A.index;
    }).map(function(B) {
      return {
        data: B.data,
        mode: B.mode,
        length: B.length
      };
    });
  }
  function d(g, w) {
    switch (w) {
      case e.NUMERIC:
        return n.getBitsLength(g);
      case e.ALPHANUMERIC:
        return r.getBitsLength(g);
      case e.KANJI:
        return i.getBitsLength(g);
      case e.BYTE:
        return o.getBitsLength(g);
    }
  }
  function v(g) {
    return g.reduce(function(w, m) {
      const h = w.length - 1 >= 0 ? w[w.length - 1] : null;
      return h && h.mode === m.mode ? (w[w.length - 1].data += m.data, w) : (w.push(m), w);
    }, []);
  }
  function C(g) {
    const w = [];
    for (let m = 0; m < g.length; m++) {
      const h = g[m];
      switch (h.mode) {
        case e.NUMERIC:
          w.push([
            h,
            { data: h.data, mode: e.ALPHANUMERIC, length: h.length },
            { data: h.data, mode: e.BYTE, length: h.length }
          ]);
          break;
        case e.ALPHANUMERIC:
          w.push([
            h,
            { data: h.data, mode: e.BYTE, length: h.length }
          ]);
          break;
        case e.KANJI:
          w.push([
            h,
            { data: h.data, mode: e.BYTE, length: u(h.data) }
          ]);
          break;
        case e.BYTE:
          w.push([
            { data: h.data, mode: e.BYTE, length: u(h.data) }
          ]);
      }
    }
    return w;
  }
  function l(g, w) {
    const m = {}, h = { start: {} };
    let p = ["start"];
    for (let b = 0; b < g.length; b++) {
      const B = g[b], A = [];
      for (let M = 0; M < B.length; M++) {
        const T = B[M], Z = "" + b + M;
        A.push(Z), m[Z] = { node: T, lastCount: 0 }, h[Z] = {};
        for (let k = 0; k < p.length; k++) {
          const L = p[k];
          m[L] && m[L].node.mode === T.mode ? (h[L][Z] = d(m[L].lastCount + T.length, T.mode) - d(m[L].lastCount, T.mode), m[L].lastCount += T.length) : (m[L] && (m[L].lastCount = T.length), h[L][Z] = d(T.length, T.mode) + 4 + e.getCharCountIndicator(T.mode, w));
        }
      }
      p = A;
    }
    for (let b = 0; b < p.length; b++)
      h[p[b]].end = 0;
    return { map: h, table: m };
  }
  function E(g, w) {
    let m;
    const h = e.getBestModeForData(g);
    if (m = e.from(w, h), m !== e.BYTE && m.bit < h.bit)
      throw new Error('"' + g + '" cannot be encoded with mode ' + e.toString(m) + `.
 Suggested mode is: ` + e.toString(h));
    switch (m === e.KANJI && !c.isKanjiModeEnabled() && (m = e.BYTE), m) {
      case e.NUMERIC:
        return new n(g);
      case e.ALPHANUMERIC:
        return new r(g);
      case e.KANJI:
        return new i(g);
      case e.BYTE:
        return new o(g);
    }
  }
  t.fromArray = function(w) {
    return w.reduce(function(m, h) {
      return typeof h == "string" ? m.push(E(h, null)) : h.data && m.push(E(h.data, h.mode)), m;
    }, []);
  }, t.fromString = function(w, m) {
    const h = S(w, c.isKanjiModeEnabled()), p = C(h), b = l(p, m), B = s.find_path(b.map, "start", "end"), A = [];
    for (let M = 1; M < B.length - 1; M++)
      A.push(b.table[B[M]].node);
    return t.fromArray(v(A));
  }, t.rawSplit = function(w) {
    return t.fromArray(
      S(w, c.isKanjiModeEnabled())
    );
  };
})(ye);
const gt = _, yt = ft, wr = Jn, pr = qn, yr = ue, Cr = fe, At = de, Nt = dt, Er = Gn, st = me, Sr = we, br = H, Ct = ye;
function Br(t, e) {
  const n = t.size, r = Cr.getPositions(e);
  for (let o = 0; o < r.length; o++) {
    const i = r[o][0], a = r[o][1];
    for (let c = -1; c <= 7; c++)
      if (!(i + c <= -1 || n <= i + c))
        for (let s = -1; s <= 7; s++)
          a + s <= -1 || n <= a + s || (c >= 0 && c <= 6 && (s === 0 || s === 6) || s >= 0 && s <= 6 && (c === 0 || c === 6) || c >= 2 && c <= 4 && s >= 2 && s <= 4 ? t.set(i + c, a + s, !0, !0) : t.set(i + c, a + s, !1, !0));
  }
}
function Ir(t) {
  const e = t.size;
  for (let n = 8; n < e - 8; n++) {
    const r = n % 2 === 0;
    t.set(n, 6, r, !0), t.set(6, n, r, !0);
  }
}
function Mr(t, e) {
  const n = yr.getPositions(e);
  for (let r = 0; r < n.length; r++) {
    const o = n[r][0], i = n[r][1];
    for (let a = -2; a <= 2; a++)
      for (let c = -2; c <= 2; c++)
        a === -2 || a === 2 || c === -2 || c === 2 || a === 0 && c === 0 ? t.set(o + a, i + c, !0, !0) : t.set(o + a, i + c, !1, !0);
  }
}
function Ar(t, e) {
  const n = t.size, r = st.getEncodedBits(e);
  let o, i, a;
  for (let c = 0; c < 18; c++)
    o = Math.floor(c / 3), i = c % 3 + n - 8 - 3, a = (r >> c & 1) === 1, t.set(o, i, a, !0), t.set(i, o, a, !0);
}
function Et(t, e, n) {
  const r = t.size, o = Sr.getEncodedBits(e, n);
  let i, a;
  for (i = 0; i < 15; i++)
    a = (o >> i & 1) === 1, i < 6 ? t.set(i, 8, a, !0) : i < 8 ? t.set(i + 1, 8, a, !0) : t.set(r - 15 + i, 8, a, !0), i < 8 ? t.set(8, r - i - 1, a, !0) : i < 9 ? t.set(8, 15 - i - 1 + 1, a, !0) : t.set(8, 15 - i - 1, a, !0);
  t.set(r - 8, 8, 1, !0);
}
function Nr(t, e) {
  const n = t.size;
  let r = -1, o = n - 1, i = 7, a = 0;
  for (let c = n - 1; c > 0; c -= 2)
    for (c === 6 && c--; ; ) {
      for (let s = 0; s < 2; s++)
        if (!t.isReserved(o, c - s)) {
          let u = !1;
          a < e.length && (u = (e[a] >>> i & 1) === 1), t.set(o, c - s, u), i--, i === -1 && (a++, i = 7);
        }
      if (o += r, o < 0 || n <= o) {
        o -= r, r = -r;
        break;
      }
    }
}
function Pr(t, e, n) {
  const r = new wr();
  n.forEach(function(s) {
    r.put(s.mode.bit, 4), r.put(s.getLength(), br.getCharCountIndicator(s.mode, t)), s.write(r);
  });
  const o = gt.getSymbolTotalCodewords(t), i = Nt.getTotalCodewordsCount(t, e), a = (o - i) * 8;
  for (r.getLengthInBits() + 4 <= a && r.put(0, 4); r.getLengthInBits() % 8 !== 0; )
    r.putBit(0);
  const c = (a - r.getLengthInBits()) / 8;
  for (let s = 0; s < c; s++)
    r.put(s % 2 ? 17 : 236, 8);
  return Tr(r, t, e);
}
function Tr(t, e, n) {
  const r = gt.getSymbolTotalCodewords(e), o = Nt.getTotalCodewordsCount(e, n), i = r - o, a = Nt.getBlocksCount(e, n), c = r % a, s = a - c, u = Math.floor(r / a), f = Math.floor(i / a), S = f + 1, d = u - f, v = new Er(d);
  let C = 0;
  const l = new Array(a), E = new Array(a);
  let g = 0;
  const w = new Uint8Array(t.buffer);
  for (let B = 0; B < a; B++) {
    const A = B < s ? f : S;
    l[B] = w.slice(C, C + A), E[B] = v.encode(l[B]), C += A, g = Math.max(g, A);
  }
  const m = new Uint8Array(r);
  let h = 0, p, b;
  for (p = 0; p < g; p++)
    for (b = 0; b < a; b++)
      p < l[b].length && (m[h++] = l[b][p]);
  for (p = 0; p < d; p++)
    for (b = 0; b < a; b++)
      m[h++] = E[b][p];
  return m;
}
function Rr(t, e, n, r) {
  let o;
  if (Array.isArray(t))
    o = Ct.fromArray(t);
  else if (typeof t == "string") {
    let u = e;
    if (!u) {
      const f = Ct.rawSplit(t);
      u = st.getBestVersionForData(f, n);
    }
    o = Ct.fromString(t, u || 40);
  } else
    throw new Error("Invalid data");
  const i = st.getBestVersionForData(o, n);
  if (!i)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!e)
    e = i;
  else if (e < i)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + i + `.
`
    );
  const a = Pr(e, n, o), c = gt.getSymbolSize(e), s = new pr(c);
  return Br(s, e), Ir(s), Mr(s, e), Et(s, n, 0), e >= 7 && Ar(s, e), Nr(s, a), isNaN(r) && (r = At.getBestMask(
    s,
    Et.bind(null, s, n)
  )), At.applyMask(r, s), Et(s, n, r), {
    modules: s,
    version: e,
    errorCorrectionLevel: n,
    maskPattern: r,
    segments: o
  };
}
se.create = function(e, n) {
  if (typeof e > "u" || e === "")
    throw new Error("No input text");
  let r = yt.M, o, i;
  return typeof n < "u" && (r = yt.from(n.errorCorrectionLevel, yt.M), o = st.from(n.version), i = At.from(n.maskPattern), n.toSJISFunc && gt.setToSJISFunction(n.toSJISFunc)), Rr(e, o, r, i);
};
var Ee = {}, Lt = {};
(function(t) {
  function e(n) {
    if (typeof n == "number" && (n = n.toString()), typeof n != "string")
      throw new Error("Color should be defined as hex string");
    let r = n.slice().replace("#", "").split("");
    if (r.length < 3 || r.length === 5 || r.length > 8)
      throw new Error("Invalid hex color: " + n);
    (r.length === 3 || r.length === 4) && (r = Array.prototype.concat.apply([], r.map(function(i) {
      return [i, i];
    }))), r.length === 6 && r.push("F", "F");
    const o = parseInt(r.join(""), 16);
    return {
      r: o >> 24 & 255,
      g: o >> 16 & 255,
      b: o >> 8 & 255,
      a: o & 255,
      hex: "#" + r.slice(0, 6).join("")
    };
  }
  t.getOptions = function(r) {
    r || (r = {}), r.color || (r.color = {});
    const o = typeof r.margin > "u" || r.margin === null || r.margin < 0 ? 4 : r.margin, i = r.width && r.width >= 21 ? r.width : void 0, a = r.scale || 4;
    return {
      width: i,
      scale: i ? 4 : a,
      margin: o,
      color: {
        dark: e(r.color.dark || "#000000ff"),
        light: e(r.color.light || "#ffffffff")
      },
      type: r.type,
      rendererOpts: r.rendererOpts || {}
    };
  }, t.getScale = function(r, o) {
    return o.width && o.width >= r + o.margin * 2 ? o.width / (r + o.margin * 2) : o.scale;
  }, t.getImageWidth = function(r, o) {
    const i = t.getScale(r, o);
    return Math.floor((r + o.margin * 2) * i);
  }, t.qrToImageData = function(r, o, i) {
    const a = o.modules.size, c = o.modules.data, s = t.getScale(a, i), u = Math.floor((a + i.margin * 2) * s), f = i.margin * s, S = [i.color.light, i.color.dark];
    for (let d = 0; d < u; d++)
      for (let v = 0; v < u; v++) {
        let C = (d * u + v) * 4, l = i.color.light;
        if (d >= f && v >= f && d < u - f && v < u - f) {
          const E = Math.floor((d - f) / s), g = Math.floor((v - f) / s);
          l = S[c[E * a + g] ? 1 : 0];
        }
        r[C++] = l.r, r[C++] = l.g, r[C++] = l.b, r[C] = l.a;
      }
  };
})(Lt);
(function(t) {
  const e = Lt;
  function n(o, i, a) {
    o.clearRect(0, 0, i.width, i.height), i.style || (i.style = {}), i.height = a, i.width = a, i.style.height = a + "px", i.style.width = a + "px";
  }
  function r() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  t.render = function(i, a, c) {
    let s = c, u = a;
    typeof s > "u" && (!a || !a.getContext) && (s = a, a = void 0), a || (u = r()), s = e.getOptions(s);
    const f = e.getImageWidth(i.modules.size, s), S = u.getContext("2d"), d = S.createImageData(f, f);
    return e.qrToImageData(d.data, i, s), n(S, u, f), S.putImageData(d, 0, 0), u;
  }, t.renderToDataURL = function(i, a, c) {
    let s = c;
    typeof s > "u" && (!a || !a.getContext) && (s = a, a = void 0), s || (s = {});
    const u = t.render(i, a, s), f = s.type || "image/png", S = s.rendererOpts || {};
    return u.toDataURL(f, S.quality);
  };
})(Ee);
var Se = {};
const kr = Lt;
function jt(t, e) {
  const n = t.a / 255, r = e + '="' + t.hex + '"';
  return n < 1 ? r + " " + e + '-opacity="' + n.toFixed(2).slice(1) + '"' : r;
}
function St(t, e, n) {
  let r = t + e;
  return typeof n < "u" && (r += " " + n), r;
}
function Lr(t, e, n) {
  let r = "", o = 0, i = !1, a = 0;
  for (let c = 0; c < t.length; c++) {
    const s = Math.floor(c % e), u = Math.floor(c / e);
    !s && !i && (i = !0), t[c] ? (a++, c > 0 && s > 0 && t[c - 1] || (r += i ? St("M", s + n, 0.5 + u + n) : St("m", o, 0), o = 0, i = !1), s + 1 < e && t[c + 1] || (r += St("h", a), a = 0)) : o++;
  }
  return r;
}
Se.render = function(e, n, r) {
  const o = kr.getOptions(n), i = e.modules.size, a = e.modules.data, c = i + o.margin * 2, s = o.color.light.a ? "<path " + jt(o.color.light, "fill") + ' d="M0 0h' + c + "v" + c + 'H0z"/>' : "", u = "<path " + jt(o.color.dark, "stroke") + ' d="' + Lr(a, i, o.margin) + '"/>', f = 'viewBox="0 0 ' + c + " " + c + '"', d = '<svg xmlns="http://www.w3.org/2000/svg" ' + (o.width ? 'width="' + o.width + '" height="' + o.width + '" ' : "") + f + ' shape-rendering="crispEdges">' + s + u + `</svg>
`;
  return typeof r == "function" && r(null, d), d;
};
const _r = Wn, Pt = se, be = Ee, Zr = Se;
function _t(t, e, n, r, o) {
  const i = [].slice.call(arguments, 1), a = i.length, c = typeof i[a - 1] == "function";
  if (!c && !_r())
    throw new Error("Callback required as last argument");
  if (c) {
    if (a < 2)
      throw new Error("Too few arguments provided");
    a === 2 ? (o = n, n = e, e = r = void 0) : a === 3 && (e.getContext && typeof o > "u" ? (o = r, r = void 0) : (o = r, r = n, n = e, e = void 0));
  } else {
    if (a < 1)
      throw new Error("Too few arguments provided");
    return a === 1 ? (n = e, e = r = void 0) : a === 2 && !e.getContext && (r = n, n = e, e = void 0), new Promise(function(s, u) {
      try {
        const f = Pt.create(n, r);
        s(t(f, e, r));
      } catch (f) {
        u(f);
      }
    });
  }
  try {
    const s = Pt.create(n, r);
    o(null, t(s, e, r));
  } catch (s) {
    o(s);
  }
}
Q.create = Pt.create;
Q.toCanvas = _t.bind(null, be.render);
Q.toDataURL = _t.bind(null, be.renderToDataURL);
Q.toString = _t.bind(null, function(t, e, n) {
  return Zr.render(t, n);
});
const Fr = (t, e) => {
  const n = Array.prototype.slice.call(
    Q.create(t, { errorCorrectionLevel: e }).modules.data,
    0
  ), r = Math.sqrt(n.length);
  return n.reduce(
    (o, i, a) => (a % r === 0 ? o.push([i]) : o[o.length - 1].push(i)) && o,
    []
  );
};
function Dr({
  ecl: t = "H",
  logoMargin: e = 10,
  logoSize: n = 50,
  size: r = 200,
  uri: o
}) {
  const a = r - parseInt("20", 10) * 2, c = Ae(() => {
    const f = [], S = Fr(o, t), d = a / S.length;
    [
      { x: 0, y: 0 },
      { x: 1, y: 0 },
      { x: 0, y: 1 }
    ].forEach(({ x: g, y: w }) => {
      const m = (S.length - 7) * d * g, h = (S.length - 7) * d * w;
      for (let p = 0; p < 3; p++)
        f.push(
          /* @__PURE__ */ y(
            "rect",
            {
              fill: p % 2 !== 0 ? "white" : "black",
              height: d * (7 - p * 2),
              rx: (p - 2) * -5 + (p === 0 ? 2 : 0),
              ry: (p - 2) * -5 + (p === 0 ? 2 : 0),
              width: d * (7 - p * 2),
              x: m + d * p,
              y: h + d * p
            },
            `${p}-${g}-${w}`
          )
        );
    });
    const C = Math.floor((n + e * 2) / d), l = S.length / 2 - C / 2, E = S.length / 2 + C / 2 - 1;
    return S.forEach((g, w) => {
      g.forEach((m, h) => {
        S[w][h] && (w < 7 && h < 7 || w > S.length - 8 && h < 7 || w < 7 && h > S.length - 8 || w > l && w < E && h > l && h < E || f.push(
          /* @__PURE__ */ y(
            "circle",
            {
              cx: w * d + d / 2,
              cy: h * d + d / 2,
              fill: "black",
              r: d / 3
            },
            `circle-${w}-${h}`
          )
        ));
      });
    }), f;
  }, [t, n, e, a, o]), s = a / 2 - n / 2, u = n + e * 2;
  return /* @__PURE__ */ y("div", { className: Ve, children: /* @__PURE__ */ P("div", { className: He, children: [
    /* @__PURE__ */ y(
      "div",
      {
        className: Ue,
        style: {
          top: s,
          width: a
        },
        children: /* @__PURE__ */ y(Gt, { fill: "purple", height: n })
      }
    ),
    /* @__PURE__ */ P("svg", { height: a, style: { all: "revert" }, width: a, children: [
      /* @__PURE__ */ y("title", { children: "QR Code" }),
      /* @__PURE__ */ P("defs", { children: [
        /* @__PURE__ */ y("clipPath", { id: "clip-wrapper", children: /* @__PURE__ */ y("rect", { height: u, width: u }) }),
        /* @__PURE__ */ y("clipPath", { id: "clip-logo", children: /* @__PURE__ */ y("rect", { height: n, width: n }) })
      ] }),
      /* @__PURE__ */ y("rect", { fill: "transparent", height: a, width: a }),
      c
    ] })
  ] }) });
}
function Ur({
  open: t,
  onClose: e,
  url: n,
  isError: r,
  error: o
}) {
  return /* @__PURE__ */ y(Kn, { open: t, titleId: "Sign In With Farcaster", onClose: e, children: /* @__PURE__ */ y("div", { className: "fc-authkit-qrcode-dialog", children: /* @__PURE__ */ P("div", { className: Yn, children: [
    /* @__PURE__ */ y(
      bt,
      {
        kind: "reset",
        onClick: e,
        style: { position: "absolute", top: 19, right: 13 },
        children: /* @__PURE__ */ y(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: 18,
            height: 18,
            fill: "none",
            children: /* @__PURE__ */ y(
              "path",
              {
                fill: "rgba(0,0,0,0.5)",
                fillRule: "evenodd",
                d: "M1.15 1.15a.937.937 0 0 1 1.325 0L9 7.674l6.525-6.524a.937.937 0 1 1 1.325 1.325L10.326 9l6.524 6.525a.937.937 0 0 1-1.325 1.325L9 10.326 2.475 16.85a.938.938 0 0 1-1.325-1.325L7.674 9 1.15 2.475a.937.937 0 0 1 0-1.325Z",
                clipRule: "evenodd"
              }
            )
          }
        )
      }
    ),
    r ? /* @__PURE__ */ P(j, { children: [
      /* @__PURE__ */ y("div", { className: Kt, children: "Error" }),
      /* @__PURE__ */ y("div", { className: $t, children: (o == null ? void 0 : o.message) ?? "Unknown error, please try again." })
    ] }) : /* @__PURE__ */ P(j, { children: [
      /* @__PURE__ */ y("div", { className: Kt, children: "Sign in with Farcaster" }),
      /* @__PURE__ */ y("div", { className: $t, children: "Scan with your phone's camera to continue." }),
      /* @__PURE__ */ y(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "center",
            marginTop: 24,
            marginBottom: 12
          },
          children: /* @__PURE__ */ y(Dr, { uri: n, size: 264, logoSize: 22, logoMargin: 12 })
        }
      ),
      /* @__PURE__ */ y("div", { style: { display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ P(
        bt,
        {
          kind: "tertiary",
          style: {
            display: "flex",
            alignItems: "center",
            fontWeight: 500
          },
          onClick: () => {
            window.location.href = n;
          },
          children: [
            /* @__PURE__ */ y(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: 12,
                height: 18,
                fill: "none",
                children: /* @__PURE__ */ y(
                  "path",
                  {
                    fill: "#7C65C1",
                    fillRule: "evenodd",
                    d: "M0 3a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Zm4-1.5v.75c0 .414.336.75.75.75h2.5A.75.75 0 0 0 8 2.25V1.5h1A1.5 1.5 0 0 1 10.5 3v12A1.5 1.5 0 0 1 9 16.5H3A1.5 1.5 0 0 1 1.5 15V3A1.5 1.5 0 0 1 3 1.5h1Z",
                    clipRule: "evenodd"
                  }
                )
              }
            ),
            /* @__PURE__ */ y("span", { style: { marginLeft: 9 }, children: "I'm using my phone →" })
          ]
        }
      ) })
    ] })
  ] }) }) });
}
var Vr = "_8rz8bk0";
function Hr({
  debug: t,
  hideSignOut: e,
  onSignOut: n,
  ...r
}) {
  const { onSuccess: o, onStatusResponse: i, onError: a } = r, c = R(
    (k) => {
      o == null || o(k);
    },
    [o]
  ), s = R(
    (k) => {
      i == null || i(k);
    },
    [i]
  ), u = R(
    (k) => {
      a == null || a(k);
    },
    [a]
  ), f = R(() => {
    n == null || n();
  }, [n]), S = Fe({
    ...r,
    onSuccess: c,
    onStatusResponse: s,
    onError: u
  }), {
    signIn: d,
    signOut: v,
    connect: C,
    reconnect: l,
    isSuccess: E,
    isError: g,
    error: w,
    channelToken: m,
    url: h,
    data: p,
    validSignature: b
  } = S, B = R(() => {
    M(!1), v(), f();
  }, [v, f]), [A, M] = N(!1), T = R(() => {
    g && l(), M(!0), d(), h && It() && (window.location.href = h);
  }, [g, l, d, h]), Z = E && b;
  return F(() => {
    m || C();
  }, [m, C]), /* @__PURE__ */ P("div", { className: "fc-authkit-signin-button", children: [
    Z ? /* @__PURE__ */ y(
      Xe,
      {
        userData: p,
        signOut: B,
        hideSignOut: !!e
      }
    ) : /* @__PURE__ */ P(j, { children: [
      /* @__PURE__ */ y(Ke, { onClick: T, label: "Sign in" }),
      h && /* @__PURE__ */ y(
        Ur,
        {
          open: A && !It(),
          onClose: () => M(!1),
          url: h,
          isError: g,
          error: w
        }
      )
    ] }),
    t && /* @__PURE__ */ y("div", { className: Vr, children: /* @__PURE__ */ y("pre", { children: JSON.stringify(S, null, 2) }) })
  ] });
}
function xr() {
  const { isAuthenticated: t, profile: e } = q();
  return { isAuthenticated: t, profile: e };
}
function Wr() {
  return /* @__PURE__ */ P(Te, { config: {
    rpcUrl: "https://mainnet.optimism.io"
  }, children: [
    /* @__PURE__ */ y("div", { style: { position: "fixed", top: 12, right: 12, zIndex: 1e3 }, children: /* @__PURE__ */ y(
      Hr,
      {
        nonce: "abcd1234",
        requestId: "some-unique-request-id",
        timeout: 2e4,
        onError: (e) => console.error("error callback:", e),
        onSuccess: (e) => console.log("success callback:", e),
        onStatusResponse: (e) => console.log("status callback:", e),
        onSignOut: () => console.log("sign out callback"),
        debug: !0
      }
    ) }),
    /* @__PURE__ */ y(Or, {})
  ] });
}
function Or() {
  const {
    isAuthenticated: t,
    profile: { fid: e, bio: n, displayName: r, custody: o }
  } = xr();
  return /* @__PURE__ */ y("div", { style: { fontFamily: "sans-serif" }, children: t && /* @__PURE__ */ P("div", { children: [
    e && /* @__PURE__ */ P("p", { children: [
      /* @__PURE__ */ y("strong", { children: "FID:" }),
      " ",
      e
    ] }),
    r && /* @__PURE__ */ P("p", { children: [
      /* @__PURE__ */ y("strong", { children: "Display name:" }),
      " ",
      r
    ] }),
    n && /* @__PURE__ */ P("p", { children: [
      /* @__PURE__ */ y("strong", { children: "Bio:" }),
      " ",
      n
    ] }),
    o && /* @__PURE__ */ P("p", { children: [
      /* @__PURE__ */ y("strong", { children: "Custody address:" }),
      " ",
      o
    ] })
  ] }) });
}
function jr() {
  const { signInMessage: t } = q();
  return t;
}
export {
  Te as AuthKitProvider,
  Wr as Demo,
  Dr as QRCode,
  Hr as SignInButton,
  lt as useAppClient,
  Re as useCreateChannel,
  xr as useProfile,
  Fe as useSignIn,
  jr as useSignInMessage,
  ke as useVerifySignInMessage,
  _e as useWatchStatus
};
